module.exports = __webpack_public_path__ + "img/pay_wechat.00459a41.png";